export enum PricingPeriodEnum {
  MONTHLY = "monthly",
  YEARLY = "yearly",
}

export enum PricingPlanVersionEnum {
  BASIC = "BASIC",
  PLUS = "PLUS",
  PRO = "PRO",
  ULTRA = "ULTRA",
}

/**
 * 用于版本升级比较
 */
export const PricingPlanVersionNumMap = {
  [PricingPlanVersionEnum.BASIC]: 1,
  [PricingPlanVersionEnum.PLUS]: 2,
  [PricingPlanVersionEnum.PRO]: 3,
  [PricingPlanVersionEnum.ULTRA]: 4,
};

export const PricingPlanVersionTextMap = {
  [PricingPlanVersionEnum.BASIC]: "Basic",
  [PricingPlanVersionEnum.PLUS]: "Plus",
  [PricingPlanVersionEnum.PRO]: "Pro",
  [PricingPlanVersionEnum.ULTRA]: "Ultra",
};

export interface IPriceInformation {
  /** 月付商品 id */
  monthlyId: string;
  /** 月付价格 */
  monthlyPrice: number;
  /** 年付商品 id */
  yearlyId: string;
  /** 年付价格 */
  yearlyPrice: number;
  /** 年付提示 */
  yearlyPayTip: string;

  // TODO 为升级 id
}

export interface IVersionWithPrice extends IPriceInformation {
  version: PricingPlanVersionEnum;
  versionNum: number;
  label: string;
}

export type VersionWithPriceMapType = Record<
  PricingPlanVersionEnum,
  IVersionWithPrice
>;

export enum PlanPayModalTypeEnum {
  /** 订阅 */
  Subscribe = "subscribe",
  /** 续费 */
  Renew = "renew",
  /** 升级 */
  Upgrade = "upgrade",
}
